import { Option, TypeaheadPropsAndState } from "react-bootstrap-typeahead/types/types";

const typeaheadFilterByContainsAll = (text: string, option: Option, typeaheadProps: TypeaheadPropsAndState) => {
  //Do not return option if it already exists in the selected options
  if (typeaheadProps?.selected?.includes(option)) {
    return false;
  }
  const { text: terms = "" } = typeaheadProps;
  return terms.split(/\s+/).every((searchTerm) => text.toLowerCase().includes(searchTerm.toLowerCase()));
};

export default typeaheadFilterByContainsAll;
